import {SponsorNames} from './sponsorNames.js';
import {PhoneNumbers} from './phoneNumbers.js';
import {Person} from './person.js';

export var Sponsor = function(sponsorData) {
    var sponsor = {};
    
    // Constructor
    if (sponsorData) {
        sponsor.id = sponsorData.id;
        sponsor.country = sponsorData.country;
        sponsor.email = sponsorData.email;
        sponsor.profilePictureUrl = sponsorData.profilePictureUrl;
        sponsor.profileThumbnailUrl = sponsorData.profileThumbnailUrl;

        sponsor.names = SponsorNames(sponsorData.names);
        sponsor.phoneNumbers = PhoneNumbers(sponsorData.phoneNumbers);
        sponsor.primaryPerson = Person(sponsorData.primaryPerson);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return sponsor;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/sponsor.js
// module id = 357
// module chunks = 0